import { SYNC_CONSTS } from "src/config";

export type TeamType = {
  value: string;
  name: string;
};

export type ChangeTeamOptions = {
  reload?: boolean;
  skipManualControl?: boolean;
};

export const TEAMS_COOKIE_KEYS = {
  currentTeam: `${SYNC_CONSTS.appUniqueName.sync}${SYNC_CONSTS.currentTeamSufix}`,
  teams: `${SYNC_CONSTS.appUniqueName.sync}${SYNC_CONSTS.teamsInfoSufix}`,
};
